import { createAsyncThunk } from "@reduxjs/toolkit";
import { customerPortal } from "@vilocnv/allsetra-core";
import { postGeozone } from "../../api/post-geozone";

type PostGeozoneRequestDto = customerPortal.geozones.PostGeozoneRequestDto;

const postGeozoneAction = createAsyncThunk(
  "geozones/postGeozoneAction",
  async (postGeozoneRequest: PostGeozoneRequestDto, thunkAPI) => {
    try {
      return await postGeozone(postGeozoneRequest);
    } catch (error: any) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default postGeozoneAction;
